
$( "button.hamburger" ).click(function() {
	$(this).toggleClass('is-active');
});